<template>
  <div class="bg-red-500/5 dark:bg-red-500/5 border border-red-500/20 dark:border-red-500/20 rounded-2xl p-6 mb-6 text-center max-w-lg mx-auto">
    <div class="flex items-center justify-center w-12 h-12 rounded-full bg-red-100 dark:bg-red-900/30 text-red-600 dark:text-red-400 mx-auto mb-4">
      <i class="fas fa-triangle-exclamation text-xl"></i>
    </div>
    <h3 class="text-base font-bold text-gray-900 dark:text-white mb-2">
      {{ title }}
    </h3>
    <p class="text-xs text-gray-500 dark:text-gray-400 mb-6">
      {{ description }}
    </p>
    <button
      :class="buttonClass"
      class="text-white px-6 py-2 uppercase text-xs font-bold rounded-xl transition-all shadow-md flex items-center mx-auto gap-2"
      @click="$emit('retry')"
    >
      <i class="fas fa-arrows-rotate"></i>
      {{ buttonText }}
    </button>
  </div>
</template>

<script>
export default {
  name: "ResearchCompassErrorCard",
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    buttonText: {
      type: String,
      default: "Retry",
    },
    buttonClass: {
      type: String,
      default: "bg-blue-600 hover:bg-blue-700 dark:bg-blue-500 dark:hover:bg-blue-600",
    },
  },
};
</script>
